// extracted by mini-css-extract-plugin
export var chevron = "mobileFooter-module--chevron--62cf7";
export var contact = "mobileFooter-module--contact--3634f";
export var content = "mobileFooter-module--content--46e6e";
export var control = "mobileFooter-module--control--42139";
export var divider = "mobileFooter-module--divider--3054a";
export var footerContent = "mobileFooter-module--footerContent--2369a";
export var footerLink = "mobileFooter-module--footerLink--e20bf";
export var footerSection = "mobileFooter-module--footerSection--f98bf";
export var footerWrapper = "mobileFooter-module--footerWrapper--9e3a4";
export var heading = "mobileFooter-module--heading--086f7";
export var heading4 = "mobileFooter-module--heading4--a9f20";
export var item = "mobileFooter-module--item--0d39f";
export var label = "mobileFooter-module--label--1b82f";
export var link = "mobileFooter-module--link--023fc";
export var logo = "mobileFooter-module--logo--7f3fa";
export var paragraph = "mobileFooter-module--paragraph--19d06";